if (!customElements.get('sticky-scroll')) {
  class StickyScroll extends HTMLElement {
    constructor() {
      super();
      this.lastScrollY = window.scrollY;
      this.currentTop = 0;
      this.boundInit = this.init.bind(this);
      this.boundOnScroll = this.onScroll.bind(this);
      this.init();
    }

    connectedCallback() {
      window.addEventListener('on:debounced-resize', this.boundInit);
    }

    disconnectedCallback() {
      window.removeEventListener('on:debounced-resize', this.boundInit);
      window.removeEventListener('scroll', this.boundOnScroll);
    }

    init() {
      const computedStyle = getComputedStyle(this);

      // Sticky - attach if unattached
      if (computedStyle.position === 'sticky' && !this.attached) {
        this.initialOffset = parseInt(computedStyle.top, 10) || 0;
        window.addEventListener('scroll', this.boundOnScroll, { passive: true });
        this.attached = true;

      // Not sticky - detach if attached
      } else if (computedStyle.position !== 'sticky' && this.attached) {
        this.style.top = '';
        window.removeEventListener('scroll', this.boundOnScroll);
        this.attached = false;
      }
    }

    onScroll() {
      // Only update on requestAnimationFrame
      if (!this.waitingToUpdate) {
        window.requestAnimationFrame(() => {
          this.updatePosition();
          this.waitingToUpdate = false;
        });
        this.waitingToUpdate = true;
      }
    }

    // [17 Aug 2026]: reads --sticky-filter-extra-offset live on every scroll
    // tick, rather than baking it into a CSS `top` override. The sticky
    // mobile-copy-reveal bar toggles a class on <html> as you scroll, and
    // this component needs its offset to reflect that immediately - a
    // value cached once in init() (on load/resize only) would go stale
    // the moment that class appears or disappears. Falls back to 0 when
    // the variable isn't set, so this is a no-op on pages without that bar.
    getExtraOffset() {
      const raw = getComputedStyle(document.documentElement).getPropertyValue('--sticky-filter-extra-offset');
      return parseInt(raw, 10) || 0;
    }

    updatePosition() {
      const scrollDelta = window.scrollY - this.lastScrollY;
      const viewportHeight = window.innerHeight;
      const elementHeight = this.offsetHeight;

    // [18 Aug 2026]: this check used to compare raw panel height against the
    // full viewport height, ignoring the panel's own sticky top offset
    // entirely. A panel could be "shorter than the viewport" on paper but
    // still have no room to reach its own bottom, since it starts partway
    // down the page (this.initialOffset + this.getExtraOffset(), the same
    // value already used below for maxTop). That mismatch is what caused
    // the filter panel to occasionally get stuck without scrolling to the
    // bottom - right at the boundary where height and offset combined
    // overflowed the viewport but this check didn't catch it. Fixed by
    // subtracting the offset here too, reusing the exact same values maxTop
    // already relies on. Safe to revert to the simpler `elementHeight <=
    // viewportHeight` check if this proves wrong somehow.
    const stickyTopOffset = this.initialOffset + this.getExtraOffset();
    if (elementHeight <= viewportHeight - stickyTopOffset) {
      this.style.top = '';
      this.lastScrollY = window.scrollY;
      return;
    }

    const minTop = viewportHeight - elementHeight;
    const maxTop = stickyTopOffset;

      this.currentTop -= scrollDelta;
      this.currentTop = Math.max(minTop, Math.min(maxTop, this.currentTop));

      this.style.top = `${this.currentTop}px`;
      this.lastScrollY = window.scrollY;
    }
  }

  customElements.define('sticky-scroll', StickyScroll);
}
